import { http } from '@/http'
import { imgServe } from '@/imageServe'

const PATH = 'app/groups/'

class GroupService {
  async getAllGroups () {
    return http.get('app/groups')
  }

  async companiesCollect () {
    return http.get(PATH.concat('companies'))
  }

  async removeStudent (gId, cId) {
    return http.delete(PATH.concat(`${gId}/customers/${cId}`))
  }

  async removeEvent (gId, tId) {
    return http.delete(PATH.concat(`${gId}/events/${tId}`))
  }

  async newGroup (data) {
    return http.post('app/groups', data)
  }

  async editGroup (gId, data) {
    return http.put(PATH.concat(gId), data)
  }

  async groupById (gId) {
    return http.get(PATH.concat(gId))
  }

  async desactiveGroup (gId) {
    return http.patch(PATH.concat(gId).concat('/archive'))
  }
}

export default new GroupService()
export { PATH }
